export const STATUS = {
  PRE_REGISTERED: { label: "Inscrição", color: "#F59E0B", bg: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  PENDING_PAYMENT: { label: "Pago (em validação)", color: "#3B82F6", bg: "bg-blue-500/15 text-blue-300 border-blue-500/30" },
  PAID: { label: "Confirmado", color: "#10B981", bg: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  CANCELLED: { label: "Cancelado", color: "#EF4444", bg: "bg-red-500/15 text-red-300 border-red-500/30" },
};

export const TIERS = {
  MASTER_OURO: { label: "Master (Ouro)", color: "#F59E0B", ring: "border-amber-500/40", chip: "bg-amber-500/15 text-amber-300" },
  PREMIUM_PRATA: { label: "Premium (Prata)", color: "#94A3B8", ring: "border-slate-400/40", chip: "bg-slate-400/15 text-slate-300" },
  GOLD_BRONZE: { label: "Gold (Bronze)", color: "#D97706", ring: "border-orange-700/40", chip: "bg-orange-700/15 text-orange-400" },
};

export const SPORT_LABEL = { CORRIDA: "Corrida", CICLISMO: "Ciclismo", KIDS: "Kids" };

export const brl = (v) =>
  (v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const maskCpf = (v) => {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

export const maskPhone = (v) => {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 10) return d.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{4})(\d)/, "$1-$2");
  return d.replace(/(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d)/, "$1-$2");
};

export const onlyDigits = (v) => (v || "").replace(/\D/g, "");

export const validateCpf = (cpf) => {
  cpf = onlyDigits(cpf);
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  for (let t = 9; t < 11; t++) {
    let sum = 0;
    for (let i = 0; i < t; i++) sum += parseInt(cpf[i]) * (t + 1 - i);
    let d = (sum * 10) % 11;
    if (d === 10) d = 0;
    if (d !== parseInt(cpf[t])) return false;
  }
  return true;
};

export const fmtDate = (s) => {
  if (!s) return "-";
  try {
    return new Date(s.length <= 10 ? s + "T00:00:00" : s).toLocaleDateString("pt-BR");
  } catch {
    return s;
  }
};

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Ocorreu um erro. Tente novamente.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
};
